define('lib/Podio.UI.Embeds',['require','translate','underscore','jquery','lib/Podio.Transport.Embeds','lib/Podio.UI','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.UI.Tooltips','signals'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var transportEmbeds = require('lib/Podio.Transport.Embeds');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var tooltips = require('lib/Podio.UI.Tooltips');
  var signalsLib = require('signals');

  var embedCreatePromise;

  var signals = {
    onEmbedDataUpdated: new signalsLib.Signal()
  };

  var handlers = {
    onDomReady : function() {
    },

    onAttachLinkButtonClick: function(elmTarget, e) {

      if(!elmTarget.is(":visible")) {
        return; // Work around for Firefox 7, which seem to keep a wrong reference to a previous action box, which is hidden
      }

      var elmForm = elmTarget.parents('.embed-attach-form');
      var elmActionBox = elmForm.parents('.action-box');

      var elmEmbedPreviewBox = elmActionBox.find('.embed-preview-box');
      var elmEmbedUrlInput = elmForm.find('.stream-embed-url');
      var elmEmbedWrapper = elmTarget.parents('.embed-wrapper');
      var appId = elmEmbedWrapper.data('app-id');

      var embedUrl = elmEmbedUrlInput.val();
      if($.trim(embedUrl).length === 0) {
        return;
      }

      if(_.isFunction(elmActionBox.data('onEmbeddingCallback'))) {
        elmActionBox.data('onEmbeddingCallback').apply(elmActionBox, []);
        elmActionBox.data('onEmbeddingCallback', null);
      }

      podioUI.disableButtonWithLoader(elmTarget);
      podioUI.disableInputField(elmEmbedUrlInput);

      embedCreatePromise = transportEmbeds.create(embedUrl, appId, onSuccess, onError);

      function onSuccess(responseData) {
        if(responseData.status == 'ok') {
          elmEmbedPreviewBox.html(responseData.data.html).show();

          var embedData = responseData.data.embed;
          $.data(elmEmbedPreviewBox[0], 'embedData', embedData);
          hideAttachEmbed(elmActionBox);
          tooltips.hideAll();
        }
        else {
          elmEmbedUrlInput.val('').focus();
        }

        podioUI.restoreButtonWithLoader(elmTarget);
        podioUI.restoreInputField(elmEmbedUrlInput);

        embedCreatePromise = null;
      }

      function onError(error, type, message) {
        podioUI.restoreButtonWithLoader(elmTarget);
        podioUI.restoreInputField(elmEmbedUrlInput);
        elmEmbedUrlInput.val('').focus();

        embedCreatePromise = null;
      }
    },

    onAttachLinkInputKeyUp : function(elmTarget, e) {
      if (e.keyCode == keyCodes.Return) {
        handlers.onAttachLinkButtonClick(elmTarget.parents('.embed-attach-form').find('button'), null);
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    },

    onAttachLinkInputPaste : function(elmTarget, e) {
      // We must wait until the paste event is done before submitting the form.
      _.defer(function(){
        handlers.onAttachLinkButtonClick(elmTarget.parents('.embed-attach-form').find('button'), null);
      });
    },
  };

  function renderEmbedBox(elmTarget) {
    var elmEmboxBox = elmTarget.find('.embed-preview-box');

    if(elmEmboxBox.length) {
      return;
    }

    var html = '<div class="embed-preview-box"></div>';
    html += '<div class="embed-attach-box">';
      html += '<div class="embed-attach-form">';
        html +=  '<table class="fluid-input-table">';
          html +=  '<tr>';
            html +=  '<td class="input-cell"><input type="text" class="stream-embed-url" placeholder="' + t("Type or paste in a web address #stream") + '" /></td>';
            html +=  '<td><button class="tooltip button-new secondary baby-button" title="'+t('Display a rich preview of any content found at the link. E.g. Images, Videos etc. #embeds')+'" data-tooltip-gravity="n" data-tooltip-max-width="200">' + t("Attach #stream") + '</button></td>';
          html +=  '</tr>';
        html += '</table>';
      html +=  '</div>';
    html +=  '</div>';

    elmEmboxBox = $(html);
    elmEmboxBox.appendTo(elmTarget);
  }

  function showAttachEmbed(elmEmbedBox, onFinishedCallback, onEmbeddingCallback, options) {
    if(!elmEmbedBox) {
      return;
    }

    if(_.isFunction(onFinishedCallback)) {
      elmEmbedBox.data('onFinishedCallback', onFinishedCallback);
    }

    if(_.isFunction(onEmbeddingCallback)) {
      elmEmbedBox.data('onEmbeddingCallback', onEmbeddingCallback);
    }

    var elmAttachBox = elmEmbedBox.find('.embed-attach-box');
    hideEmbedPreview(elmEmbedBox);
    elmAttachBox.show();

    if (!(options && options.stealFocus === false)) {
      elmAttachBox.find('input[type=text]').val('').focus();
    }
  }

  function hideAttachEmbed(elmEmbedBox) {
    if(!elmEmbedBox) {
      return;
    }

    var elmAttachBox = elmEmbedBox.find('.embed-attach-box');
    elmAttachBox.hide();

    if(_.isFunction( elmEmbedBox.data('onFinishedCallback') )) {
       elmEmbedBox.data('onFinishedCallback').apply(elmEmbedBox, []);
    }
  }

  function hideEmbedPreview(elmEmbedBox) {
    if(!elmEmbedBox) {
      return;
    }

    var elmEmbedPreviewBox = elmEmbedBox.find('.embed-preview-box');

    if(!elmEmbedPreviewBox.length) {
      return;
    }

    elmEmbedPreviewBox.empty().hide();
    $.data(elmEmbedPreviewBox.get(0), 'embedData', {});
  }

  function getCurrentEmbedInfo(elmEmbedBox) {
    if(!elmEmbedBox) {
      return;
    }

    var elmEmbedPreviewBox = elmEmbedBox.find('.embed-preview-box');
    if(!elmEmbedPreviewBox.length) {
      return;
    }

    return $.data(elmEmbedPreviewBox.get(0), 'embedData');
  }

  function clearEmbedInfo(elmEmbedBox){
    if(!elmEmbedBox) {
      return;
    }

    var elmEmbedPreviewBox = elmEmbedBox.find('.embed-preview-box');
    if(!elmEmbedPreviewBox.length) {
      return;
    }

    $.data(elmEmbedPreviewBox.get(0), 'embedData', null);
  }

  function embedUrl(elmActionBox, url, onFinishedCallback, onEmbeddingCallback) {
    if(!elmActionBox) {
      return;
    }

    renderEmbedBox(elmActionBox);
    showAttachEmbed(elmActionBox, onFinishedCallback, onEmbeddingCallback);
    elmActionBox.show();

    var elmForm = elmActionBox.find('.embed-attach-form');
    var elmEmbedUrlInput = elmForm.find('.stream-embed-url');

    elmEmbedUrlInput.val(url);
    handlers.onAttachLinkButtonClick(elmForm.find('button'), null);
  }

  function isShowingPreview(elmActionBox) {
    return elmActionBox.find('.embed-preview-box:visible').length;
  }

  function abortEmbedCreate(elmActionBox) {
    if (embedCreatePromise) {
      embedCreatePromise.abort();
      embedCreatePromise = null;
      return true;
    }
    return false;
  }

  podioEvent.bind(podioEvent.Types.init, handlers.onDomReady);
  eventUI.bind('click', '.embed-attach-form button', handlers.onAttachLinkButtonClick);
  eventUI.bind('keydown', '.embed-attach-form input[type=text]', handlers.onAttachLinkInputKeyUp, true);
  eventUI.bind('paste', '.embed-attach-form input[type=text]', handlers.onAttachLinkInputPaste, true);

  return {
    renderEmbedBox : renderEmbedBox,
    showAttachEmbed: showAttachEmbed,
    hideAttachEmbed: hideAttachEmbed,
    hideEmbedPreview : hideEmbedPreview,
    getCurrentEmbedInfo: getCurrentEmbedInfo,
    clearEmbedInfo: clearEmbedInfo,
    abortEmbedCreate: abortEmbedCreate,
    embedUrl: embedUrl,
    isShowingPreview: isShowingPreview,
    signals: signals
  };

});

